<template>
    <div class="absolute inset-0 px-2 text-center sm:px-4">
        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { SliderSymbol } from "./slider.const";

let sliderProvide = inject<any>(SliderSymbol);
if (!sliderProvide) throw new Error("sliderProvide");
sliderProvide.methods.addSlide(getCurrentInstance());
</script>
